var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"mt-12":""}},[_c('h1',{staticClass:"ma-10"},[_vm._v("Gracias, Nos comunicaremos pronto.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }